<template>
<div class="content">
  <div v-if="success" class="pop-up">
    <div class="message">
      謝謝您所提供的爆料訊息！
      <div class="btn btn-primary rounded-0 py-3 px-4
      h-auto d-block mt-2" @click="success = false">
        確定
      </div>
    </div>
  </div>
  <div class="row justify-content-center">
    <div class="col-md-10">
      <div class="row justify-content-center">
        <div class="col-md-6">
          <h3 class="heading mb-4">壹蘋新聞網爆料專線</h3>

          <p>
            <img
              src="https://static.nextapple.tw/large__494d3ba94f.jpg"
              alt="Image"
              class="img-fluid"
            />
          </p>
          <p>
            你敢爆、我敢衝，《壹蘋新聞網》線上爆料最方便，路見不平快來信，《壹蘋》與你一起為公義而戰！
          </p>
        </div>
        <div class="col-md-6">
          <form
            class="mb-5"
            method="post"
            id="contactForm"
            name="contactForm"
            @submit.prevent="submitForm"
            ref="form"
          >
            <div class="row">
              <div class="col-md-12 form-group">
                <input
                  v-model="form.title"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': !validTitle }"
                  name="name"
                  id="name"
                  :placeholder="`爆料主旨 (${titleMaxLength}字以內)`"
                />
                <div class="invalid-feedback">
                  {{ titleTooLong ? `請把 爆料主旨 保持在${titleMaxLength}字以內` : '請輸入 爆料主旨' }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 form-group">
                <textarea
                  v-model="form.description"
                  class="form-control"
                  name="description"
                  id="description"
                  :style="{height: '180px'}"
                  :class="{ 'is-invalid': !validDesc }"
                  placeholder="爆料投訴內容 *"
                ></textarea>
                <div class="invalid-feedback">
                  請輸入 爆料投訴內容
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 form-group">
                <label class="btn btn-primary">
                  <font-awesome-icon icon="fa-solid fa-image" /> 檔案上傳
                  <input
                    type="file"
                    style="display: none"
                    id="mediaupload"
                    name="mediaupload"
                    multiple
                    accept="image/*, video/*"
                    v-on:change="uploadFiles"
                  />
                </label>
                <div class="gallery">
                  <div v-for="(file, i) in files" :id="i">
                    <div
                      class="preview"
                      :style="{
                        backgroundImage: file.isImage
                          ? 'url(' + file.preview + ')'
                          : null,
                      }"
                    >
                      <div class="progress">
                        <div
                          class="progress-bar bg-info"
                          role="progressbar"
                          :style="{ width: file.progress + '%' }"
                        ></div>
                      </div>
                      <div v-if="!file.isImage" class="text-center">
                        <font-awesome-icon icon="fa-solid fa-file-video" /> 影片
                        <div style="font-size: 12px">{{ file.name }}</div>
                      </div>
                    </div>
                  </div>
                </div>


                <div v-if="files.length">
                  <div v-if="uploading">上傳中...</div>
                  <div v-else class="text-success"><font-awesome-icon icon="fa-solid fa-check" />上傳完成</div>
                </div>

              </div>
            </div>
            <div class="row">
              <div class="col-md-12 form-group">
                <input
                  v-model="form.name"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': !validName }"
                  name="name"
                  id="name"
                  placeholder="姓名 *"
                />
                <div class="invalid-feedback">
                  請輸入 姓名
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 form-group">
                <input
                  v-model="form.email"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': !validEmail }"
                  name="email"
                  id="email"
                  placeholder="E-mail信箱 *"
                />
                <div class="invalid-feedback">
                  請輸入正確的 E-mail 信箱
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 form-group">
                <input
                  v-model="form.tel"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': !validTel }"
                  name="tel"
                  id="tel"
                  placeholder="聯繫電話"
                />
                <div class="invalid-feedback">
                  請輸入正確的 聯繫電話
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 form-group">
                <input
                  v-model="form.location"
                  type="text"
                  class="form-control"
                  name="location"
                  id="location"
                  placeholder="所在縣市"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-12">* 必填</div>
            </div>
            <div class="row">
              <div class="col-12">
                <input
                  :disabled="!canSubmit"
                  type="submit"
                  :value="submitBtnText"
                  class="btn btn-primary rounded-0 py-2 px-4"
                />
                <span class="submitting"></span>
              </div>
            </div>
          </form>

          <!-- <div id="form-message-warning mt-4"></div> -->
          <div id="form-message-success" v-if="success">謝謝您</div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      titleMaxLength: 15,
      message: "Ready",
      files: [],
      success: false,
      submitted: false,
      shouldCheck: false,
      loading: false,
      form: {
        title: "",
        name: "",
        tel: "",
        email: "",
        description: "",
        location: "",
        files: [],
      },
    };
  },
  mounted() {

  },
  computed: {
    submitBtnText() {
      if (this.uploading) {
        return '請等待上傳完成';
      }

      if (this.loading) {
        return '提交中...';
      }

      return '提交';
    },
    uploading() {
      let ready = true;

      for (var i = 0; i < this.files.length; i++) {
        ready = ready && this.files[i].ready;
      }

      return !ready;
    },
    canSubmit() {
      return !this.uploading;
    },
    titleTooLong() {
      return this.form.title.length > this.titleMaxLength;
    },
    isValid() {
      let valid = true;
      valid = valid && this.validDesc;
      valid = valid && this.validEmail;
      valid = valid && this.validName;
      valid = valid && this.validTitle;
      valid = valid && this.validTel;
      valid = valid && !this.uploading;
      return valid;
    },
    validTitle() {
      return !this.shouldCheck || !this.titleTooLong;
    },
    validName() {
      return !this.shouldCheck || this.form.name.length;
    },
    validDesc() {
      return !this.shouldCheck || this.form.description.length;
    },
    validEmail() {
      if (!this.shouldCheck && !this.form.email) {
        return true;
      }

      return /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/i.test(this.form.email);
    },
    validTel() {
      if (!this.form.tel) {
        return true;
      }

      return /09\d{2}\-?\d{3}\-?\d{3}/.test(this.form.tel);
    }
  },
  methods: {
    submitForm() {
      this.shouldCheck = true;

      if (!this.isValid || this.loading) {
        return;
      }

      this.loading = true;
      this.submitted = true;
      const files = [];
      for (var i = 0; i < this.files.length; i++) {
        const file = this.files[i];
        files.push({
          key: file.key,
          name: file.name,
          isImage: file.isImage
        });
      }
      this.form.files = files;

      axios
        .post("/api/upload", this.form)
        .then(() => {
          this.success = true;
          this.shouldCheck = false;
          this.form = {
            title: "",
            name: "",
            tel: "",
            email: "",
            description: "",
            location: "",
            files: [],
          };

          this.loading = false;
        })
        .catch(() => {
          this.submitted = false;
          this.loading = false;
        });
    },
    uploadFiles(e) {
      const files = e.target.files;

      if (files) {
        var filesAmount = files.length;

        for (let i = 0; i < filesAmount; i++) {
          var reader = new FileReader();

          reader.onload = (event) => {
            const dataUrl = event.target.result;
            const ext = "." + files[i].name.split(".").pop();

            axios
              .get("/api/upload/pre-sign", { params: { ext } })
              .then((resp) => {
                const url = resp.data.url;
                const key = resp.data.key;
                var formData = new FormData();
                const isImage = dataUrl && dataUrl.startsWith("data:image");
                formData.append("file", files[i]);

                const result = {
                  preview: isImage ? dataUrl : "",
                  isImage: isImage,
                  key: key,
                  progress: 0,
                  ready: false,
                  name: files[i].name,
                };

                this.files.push(result);
                return axios
                  .put(url, files[i], {
                    headers: {
                      "Content-Type": files[i].type,
                    },
                    onUploadProgress: (progressEvent) => {
                      const progress = parseInt(
                        Math.round(
                          (progressEvent.loaded / progressEvent.total) * 100
                        )
                      );
                      const staging = this.files;
                      for (var j = 0; j < staging.length; j++) {
                        if (staging[j].key === key) {
                          staging[j].progress = progress;
                        }
                      }
                    },
                  })
                  .then(() => {
                    const staging = this.files;
                    for (var j = 0; j < staging.length; j++) {
                      if (staging[j].key === key) {
                        staging[j].ready = true;
                      }
                    }
                  });
              });
          };

          reader.readAsDataURL(files[i]);
        }
      }
    },
  },
};
</script>
